import React, { useState,useEffect } from "react";
import {
  Box,
  Grid,
  Typography,
  Button,
  Card,
  CardContent,
  Divider,
  useTheme,
  IconButton,
  Alert,
  Dialog,
  DialogTitle,
  DialogContent,
  TextField,
  Select,
  MenuItem,
  Table,
  TableHead,
  TableRow,
  TableCell,
  TableBody,
  DialogActions,
} from "@mui/material";
import ChangeLimitsModal from "./ChangeLimitsModal";

import CreditCardIcon from "@mui/icons-material/CreditCard";
import HistoryIcon from "@mui/icons-material/History";
import LockIcon from "@mui/icons-material/Lock";
import ListAltIcon from "@mui/icons-material/ListAlt";
import HelpOutlineIcon from "@mui/icons-material/HelpOutline";
import VpnKeyIcon from "@mui/icons-material/VpnKey";
import RemoveRedEyeIcon from "@mui/icons-material/RemoveRedEye";
import VisibilityOffIcon from "@mui/icons-material/VisibilityOff";
import WifiIcon from "@mui/icons-material/Wifi";
import ArrowDropUpIcon from "@mui/icons-material/ArrowDropUp";
import Chart from "react-apexcharts";
import { Stack } from "@mui/system";
import DashboardHeader from "../Dashboard/DashboardHeader";
import ChangePinPopup from "./ChangePinPopup";
import axios from "axios";
import { useSelector } from "react-redux";
import { baseapi } from "../Environmentalurl";
import { ApplicationType, date, entity_id, faq, getGeolocation, location, locationGeo, Platform } from "../Utils/Const";
import ForgotRuPayPinDialog from "./ForgotRuPayPinDialog";
import BlockCardDialog from "./BlockCardDialog";
import { useNavigate } from "react-router-dom";
import { Chip } from "@mui/material";
import PictureAsPdfIcon from "@mui/icons-material/PictureAsPdf";
import FileDownloadIcon from "@mui/icons-material/FileDownload";
import * as XLSX from "xlsx";
import jsPDF from "jspdf";
import "jspdf-autotable";
import ApplyPhysicalcard from "./ApplyPhysicalcard";
import Rupayhomefirstrow from "./Rupayhomefirstrow";
import autoTable from "jspdf-autotable";
import useIPAddress from "../Utils/useIPAddress";
import api from "../Utils/Api";

export default function Rupayrecentactiivty({ open, onClose, onSubmit }) {
  const [openPinPopup, setOpenPinPopup] = useState(false);
  const [openForgotPinPopup, setOpenForgotPinPopup] = useState(false);
  const [OpenBlockCard, setOpenBloackCard] = useState(false);
  const [showPin, setShowPin] = useState(false);
  const [showCardDetails, setShowCardDetails] = useState(false);
  const [fullCard, setFullCard] = useState("");
  const [expiry, setExpiry] = useState("");
  const [cvv, setCvv] = useState("");
  const [openTxnLimit, setOpenTxnLimit] = useState(false);
  const [encKey, setEncKey] = useState("");
  const [hexXor, setHexXor] = useState("");
  const [encryptedRpin, setEncryptedRpin] = useState("");
  const [encCardNumber, setEncCardNumber] = useState("");
  const [expDate, setExpDate] = useState("");
  const [cvvNumber, setCvvNumber] = useState("");
  const [openRpinDialog, setOpenRpinDialog] = useState(false);
  const [openComingSoon, setOpenComingSoon] = useState(false);
  const [enteredRpin, setEnteredRpin] = useState("");
  const [openErrorPopup, setOpenErrorPopup] = useState(false);
  const [errorMessage, setErrorMessage] = useState("");
  const [categories, setCategories] = useState([]);
  const [selectedCategory, setSelectedCategory] = useState("ALL");
  const [txnData, setTxnData] = useState([]);
  const [page, setPage] = useState(1);
  const rowsPerPage = 5;
  const [rpin, setRpin] = useState("");
  const [timer, setTimer] = useState(0);
  const [openTpinDialog, setOpenTpinDialog] = useState(false);
  const [tpin, setTpin] = useState("");
  const [openKycPopup, setOpenKycPopup] = useState(false);
  const [tpinOpen, setTpinOpen] = useState(false);
const ip = useIPAddress();
  const [isKycDone, setIsKycDone] = useState(
    sessionStorage.getItem("Is_KYC_Done") || "2",
  );

  const downloadExcel = () => {
    const data = filteredTxnData.map((row) => ({
      "Order ID": row.OrderID,
      Mobile: row.MobileNumber,
      Amount: row.Amount,
      Status: row.TrxnStatus,
      Narration: row.Narration,
      Date: new Date(row.InsertDatetime).toLocaleString(),
      Category: row.Category,
    }));

    const worksheet = XLSX.utils.json_to_sheet(data);
    const workbook = XLSX.utils.book_new();
    XLSX.utils.book_append_sheet(workbook, worksheet, "Transactions");

    XLSX.writeFile(workbook, "transactions.xlsx");
  };
  const downloadPDF = () => {
    const doc = new jsPDF("p", "mm", "a4");

    doc.setFontSize(14);
    doc.text("Transaction History", 14, 15);

    const tableBody =
      filteredTxnData && filteredTxnData.length > 0
        ? filteredTxnData.map((row) => [
            row.OrderID || "-",
            row.MobileNumber || "-",
            `₹${row.Amount || 0}`,
            row.TrxnStatus || "-",
            row.Narration || "-",
            new Date(row.InsertDatetime).toLocaleString(),
            row.Category || "-",
          ])
        : [["No transactions available", "", "", "", "", "", ""]];

    autoTable(doc, {
      startY: 22,
      head: [
        [
          "Order ID",
          "Mobile",
          "Amount",
          "Status",
          "Narration",
          "Date",
          "Category",
        ],
      ],
      body: tableBody,
      styles: {
        fontSize: 8,
        cellPadding: 2,
      },
      headStyles: {
        fillColor: [77, 182, 77],
        textColor: 255,
      },
      didDrawCell: (data) => {
        if (
          filteredTxnData.length === 0 &&
          data.row.index === 0 &&
          data.column.index === 0
        ) {
          doc.setFontSize(10);
        }
      },
    });

    doc.save("transactions.pdf");
  };

  const getDefaultFromDate = () => {
    const d = new Date();
    d.setMonth(d.getMonth() - 1); // ✅ last 1 month
    return d.toISOString().slice(0, 10); // yyyy-mm-dd
  };

  const getDefaultToDate = () => date;

  const [fromTxnDate, setFromTxnDate] = useState(getDefaultFromDate());
  const [toTxnDate, setToTxnDate] = useState(getDefaultToDate());

  useEffect(() => {
    if (isKycDone === "2") {
      setOpenKycPopup(true);
    }
  }, [isKycDone]);

  let timerInterval = null;

  const theme = useTheme();
  const isDark = theme.palette.mode === "dark";
  const navigate = useNavigate();

  // Apex Chart Config
  const chartOptions = {
    chart: {
      type: "bar",
      toolbar: { show: false },
      fontFamily: "Inter, sans-serif",
      offsetY: -50,
    },
    grid: {
      borderColor: "#eee",
      strokeDashArray: 4,
      padding: {
        top: -20, // 🔥 Removes extra top padding
      },
    },
    xaxis: {
      categories: ["Mon", "Tue", "Wed", "Thu", "Fri", "Sat", "Sun"],
      labels: { style: { colors: "#777", fontSize: "12px" } },
    },
    yaxis: {
      labels: { style: { colors: "#777", fontSize: "12px" } },
    },
    plotOptions: { bar: { borderRadius: 8, columnWidth: "45%" } },
    colors: [
      "#1E1E1E",
      "#1E1E1E",
      "#1E1E1E",
      "#1E1E1E",
      "#4ADE80", // Highlight Friday
      "#1E1E1E",
      "#1E1E1E",
    ],
    grid: { borderColor: "#eee", strokeDashArray: 4 },
    dataLabels: { enabled: false },
    states: {
      hover: { filter: { type: "lighten", value: 0.15 } },
    },
  };

  const chartSeries = [
    { name: "Spending", data: [150, 220, 180, 260, 400, 230, 280] },
  ];

  const getCurrentDateTime = () =>date;

  const normalizeStatus = (s = "") => s.toUpperCase();
  const formatDateForApi = (value) => {
    if (!value) return "";
    const d = new Date(value);
    return d.toISOString().slice(0, 19).replace("T", " ");
  };

  // Recent transactions
  const fetchRupayTransactions = async () => {
    try {
      const payload = {
        ReqType: "Jan_Aadhaar_eWallet_Get_Rupay_Payment_Details_Report",
        Mobilenumber: JSON.parse(sessionStorage.getItem("mobileNumber")),
        Platform,
        ApplicationType,
        EntityID: entity_id,
        GeoLocation: locationGeo,
        MachineID: ip,
        SessionID: JSON.parse(sessionStorage.getItem("SessionID")),
        Date: getCurrentDateTime(),
      };

      if (fromTxnDate) payload.From_Date = formatDateForApi(fromTxnDate);
      if (toTxnDate) payload.To_Date = formatDateForApi(toTxnDate);
      const res = await api.post(
        `${baseapi}/EWalletGetRupayPaymentDetailsReport`,
        payload,
      );

      if (res?.data?.Response_Code === "2052" && res.data.Info) {
        setCategories(res.data.Info.Table || []);
        setTxnData(res.data.Info.Table1 || []);
      } else {
        setCategories([]);
        setTxnData([]);
      }
    } catch (err) {
      console.error(err);
    }
  };

  useEffect(() => {
    fetchRupayTransactions();
    setPage(1); // reset pagination
  }, [fromTxnDate, toTxnDate]);

  const filteredTxnData =
    selectedCategory === "ALL"
      ? txnData
      : txnData.filter((t) => t.Category === selectedCategory);

  const paginatedData = filteredTxnData.slice(
    (page - 1) * rowsPerPage,
    page * rowsPerPage,
  );

  const totalPages = Math.ceil(filteredTxnData.length / rowsPerPage);

  const topButtons = [
    {
      icon: <CreditCardIcon />,
      label: "Transaction Limit",
      onClick: () => setOpenTxnLimit(true),
    },
    {
      icon: <VpnKeyIcon />,
      label: "Change PIN",
      onClick: () => setOpenPinPopup(true),
    },
    {
      icon: <VpnKeyIcon />,
      label: "Forgot PIN",
      onClick: () => setOpenForgotPinPopup(true),
    },
    {
      icon: <LockIcon />,
      label: "Card Block / Unblock",
      onClick: () => setOpenBloackCard(true),
    },
    // { icon: <HistoryIcon />, label: "Transaction History" },
    {
      icon: <ListAltIcon />,
      label: "Apply Physical Card",
      onClick: () => {
        if (isKycDone === "2") {
          setOpenKycPopup(true); // 🔒 KYC BLOCK
          return;
        }
        setOpenTpinDialog(true); // ✅ Allowed
      },
    },

    {
      icon: <HelpOutlineIcon />,
      label: "FAQ",
      onClick: () => window.open(faq),
    },
  ];

  const rupayRefNo = useSelector((state) => state.auth.rupayRefNo);
  console.log("rupayRefNo" + rupayRefNo);
  {
  }

  return (
    <>
      <>
        <Box>
          <Box
            sx={{
              display: "flex",
              justifyContent: "space-between",
              mb: 2,
            }}
          >
            <Typography fontWeight={600}>Recent Activity</Typography>
          </Box>
          <Box
            display="flex"
            justifyContent="space-between"
            mb={2}
            flexWrap="wrap"
            gap={2}
          >
            {/* LEFT */}
            <Box display="flex" justifyContent={"space-between"}>
              <Box display="flex" gap={2}>
                <TextField
                  type="date"
                  label="From Date"
                  size="small"
                  InputLabelProps={{ shrink: true }}
                  value={fromTxnDate}
                  onChange={(e) => setFromTxnDate(e.target.value)}
                />

                <TextField
                  type="date"
                  label="To Date"
                  size="small"
                  InputLabelProps={{ shrink: true }}
                  value={toTxnDate}
                  onChange={(e) => setToTxnDate(e.target.value)}
                />

                <Button
                  variant="contained"
                  sx={{ color: "white" }}
                  onClick={() => {
                    console.log("Submit clicked");
                    fetchRupayTransactions();
                  }}
                >
                  Submit
                </Button>
              </Box>
            </Box>

            {/* RIGHT */}
            <Box display="flex" gap={2}>
              <Select
                size="small"
                value={selectedCategory}
                onChange={(e) => setSelectedCategory(e.target.value)}
                sx={{ minWidth: 180 }}
              >
                <MenuItem value="ALL">All Categories</MenuItem>
                {categories.map((c, i) => (
                  <MenuItem key={i} value={c.Category}>
                    {c.Category}
                  </MenuItem>
                ))}
              </Select>

              {/* Excel */}
              <IconButton
                onClick={downloadExcel}
                sx={{
                  bgcolor: "#e6f4ea",
                  "&:hover": { bgcolor: "#d1fae5" },
                }}
                title="Download Excel"
              >
                <FileDownloadIcon sx={{ color: "#15803d" }} />
              </IconButton>

              {/* PDF */}
              <IconButton
                onClick={downloadPDF}
                sx={{
                  bgcolor: "#fee2e2",
                  "&:hover": { bgcolor: "#fecaca" },
                }}
                title="Download PDF"
              >
                <PictureAsPdfIcon sx={{ color: "#b91c1c" }} />
              </IconButton>
            </Box>
          </Box>

          <Grid item xs={12}>
            <Box mt={3}>
              <Card
                sx={{
                  borderRadius: 4,
                  p: 3,
                  mb: 2,
                  bgcolor: isDark ? "#0B1C30" : "#f5f5f5",
                  borderRadius: 2,
                  border: isDark
                    ? "1px solid rgba(90, 126, 173, 0.49)"
                    : "1px solid rgba(0,0,0,0.2)",
                }}
              >
                <Box sx={{ overflowX: "auto" }}>
                  <Table
                    size="small"
                    stickyHeader
                    sx={{
                      minWidth: 900,
                      "& thead th": {
                        fontWeight: 700,
                        fontSize: 13,
                        backgroundColor: isDark ? "#0E2239" : "#f9fafb",
                        borderBottom: "1px solid #e5e7eb",
                      },
                      "& tbody tr": {
                        transition: "background 0.2s",
                      },
                      "& tbody tr:hover": {
                        backgroundColor: isDark ? "#0E2239" : "#f3f4f6",
                      },
                      "& td": {
                        fontSize: 13,
                        borderBottom: "1px solid #e5e7eb",
                        whiteSpace: "nowrap",
                      },
                    }}
                  >
                    <TableHead>
                      <TableRow>
                        <TableCell>Order ID</TableCell>
                        <TableCell>Mobile</TableCell>
                        <TableCell align="right">Amount</TableCell>
                        <TableCell>Status</TableCell>
                        <TableCell>Narration</TableCell>
                        <TableCell>Date</TableCell>
                        <TableCell>Category</TableCell>
                      </TableRow>
                    </TableHead>

                    <TableBody>
                      {paginatedData.length === 0 ? (
                        <TableRow>
                          <TableCell colSpan={7} align="center" sx={{ py: 4 }}>
                            <Typography fontSize={14} color="text.secondary">
                              No transactions found
                            </Typography>
                          </TableCell>
                        </TableRow>
                      ) : (
                        paginatedData.map((row, i) => (
                          <TableRow key={i}>
                            <TableCell sx={{ fontWeight: 600 }}>
                              {row.OrderID}
                            </TableCell>

                            <TableCell>{row.MobileNumber}</TableCell>

                            <TableCell align="right" sx={{ fontWeight: 600 }}>
                              ₹{row.Amount}
                            </TableCell>

                            <TableCell>
                              <Chip
                                label={row.TrxnStatus}
                                size="small"
                                sx={{
                                  fontWeight: 600,
                                  textTransform: "uppercase",
                                  backgroundColor:
                                    normalizeStatus(row.TrxnStatus) ===
                                    "SUCCESS"
                                      ? "#dcfce7"
                                      : normalizeStatus(row.TrxnStatus) ===
                                          "FAILURE"
                                        ? "#fee2e2"
                                        : "#fef3c7",
                                  color:
                                    normalizeStatus(row.TrxnStatus) ===
                                    "SUCCESS"
                                      ? "#166534"
                                      : normalizeStatus(row.TrxnStatus) ===
                                          "FAILURE"
                                        ? "#991b1b"
                                        : "#92400e",
                                }}
                              />
                            </TableCell>

                            <TableCell
                              sx={{
                                maxWidth: 220,
                                overflow: "hidden",
                                textOverflow: "ellipsis",
                              }}
                              title={row.Narration}
                            >
                              {row.Narration}
                            </TableCell>

                            <TableCell>
                              {new Date(row.InsertDatetime).toLocaleString()}
                            </TableCell>

                            <TableCell>
                              <Chip
                                label={row.Category}
                                size="small"
                                variant="outlined"
                                sx={{ fontSize: 11 }}
                              />
                            </TableCell>
                          </TableRow>
                        ))
                      )}
                    </TableBody>
                  </Table>
                  {filteredTxnData.length > rowsPerPage && (
                    <Box
                      mt={2}
                      display="flex"
                      justifyContent="space-between"
                      alignItems="center"
                    >
                      <Typography fontSize={13} color="text.secondary">
                        Page {page} of {totalPages}
                      </Typography>

                      <Box display="flex" gap={1}>
                        <Button
                          size="small"
                          variant="outlined"
                          disabled={page === 1}
                          onClick={() => setPage((p) => p - 1)}
                        >
                          Previous
                        </Button>

                        <Button
                          size="small"
                          variant="outlined"
                          disabled={page === totalPages}
                          onClick={() => setPage((p) => p + 1)}
                        >
                          Next
                        </Button>
                      </Box>
                    </Box>
                  )}
                </Box>
              </Card>
            </Box>
          </Grid>
        </Box>
        {/* CHANGE PIN POPUP */}
      </>
    </>
  );
}
